import {Component, OnDestroy, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {ApiService} from '../../../services/api.service';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../services/authentication.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Chart} from 'chart.js';
import * as _ from 'lodash';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-dashboard-document',
  templateUrl: './dashboard-document.component.html',
  styleUrls: ['./dashboard-document.component.scss']
})
export class DashboardDocumentComponent implements OnInit, OnDestroy {
  monthList = [];
  dashboards: SelectItem[];
  Dashboard: any[];
  yearList: any[] = [];
  selectedCompany: SelectItem[];
  company: any;
  selectedMonth: any;
  selectedYear: any;
  charts_signing_counter_bar_stacked: any = null;
  monthly_loading = false;
  charts_signing_counter_bar_stacked_title = '';
  subs: Subscription;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private authService: AuthenticationService,
    private translate: TranslateService) {
    this.dashboards = [
      {label: 'Documents Dashboard', value: 1},
      {label: 'SMS Dashboard', value: 2},
      {label: 'Emails Dashboard', value: 3},
      {label: 'Document Request Dashboard', value: 4},
    ];
  }

  ngOnInit() {
    this.translate.get('COMMON.ALL').subscribe(() => {
      this.populateDropdown();
      this.loadMonthList();
      this.loadMonthlyData();
    });
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadMonthList();
      this.loadMonthlyData();
    });
  }

  loadMonthList() {
    this.monthList = [];
    this.monthList.push(
      this.translate.instant('MONTH.JANUARY'), this.translate.instant('MONTH.FEBRUARY'),
      this.translate.instant('MONTH.MARCH'), this.translate.instant('MONTH.APRIL'),
      this.translate.instant('MONTH.MAY'), this.translate.instant('MONTH.JUNE'),
      this.translate.instant('MONTH.JULY'), this.translate.instant('MONTH.AUGUST'),
      this.translate.instant('MONTH.SEPTEMBER'), this.translate.instant('MONTH.OCTOBER'),
      this.translate.instant('MONTH.NOVEMBER'), this.translate.instant('MONTH.DECEMBER')
    );
  }

  populateDropdown() {
    this.company = [{
      label: 'ทั้งหมด',
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  // load data from current month
  loadMonthlyData() {
    const data = {};

    if (this.selectedYear) {
      data['year'] = this.selectedYear;
    }
    if (this.selectedCompany != null) {
      data['company_id'] = this.selectedCompany;
    }
    this.monthly_loading = true;
    this.apiService.getDashboardMonthlyData(data).subscribe(
      (obj: any) => {
        this.monthly_loading = false;

        if (obj.signing_counter) {
          this.create_signing_counter_bar_stacked(obj.signing_counter);
        }

        Chart.plugins.register({
          beforeDraw: function (chart) {
            if (chart.config.options.elements.center) {
              chart.clear();
              // Get ctx from string
              const ctx = chart.chart.ctx;

              // Get options from the center object in options
              const centerConfig = chart.config.options.elements.center;
              const fontStyle = centerConfig.fontStyle || 'Arial';
              const txt = centerConfig.text;
              const color = centerConfig.color || '#000';
              const sidePadding = centerConfig.sidePadding || 20;
              const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
              // Start with a base font of 30px
              ctx.font = '30px ' + fontStyle;
              const stringWidth = ctx.measureText(txt).width;
              const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

              // Find out how much the font can grow in width.
              const widthRatio = elementWidth / stringWidth;
              const newFontSize = Math.floor(30 * widthRatio);
              const elementHeight = (chart.innerRadius * 2);

              // Pick a new font size so it will not be larger than the height of label.
              const fontSizeToUse = Math.min(newFontSize, elementHeight);

              // Set font settings to draw it correctly.
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
              const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 1.2);
              ctx.font = fontSizeToUse + 'px ' + fontStyle;
              ctx.fillStyle = color;

              // Draw text in center
              ctx.fillText(txt, centerX, centerY);
            }
          },

          afterDraw: function (chart) {
            if (chart.data.datasets.length === 0) {
              // No data is present
              const ctx = chart.chart.ctx;
              const width = chart.chart.width;
              const height = chart.chart.height;
              chart.clear();

              ctx.save();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.font = '14pt Tahoma';
              ctx.fillStyle = '#000';
              ctx.fillText('ไม่ข้อมูลแสดง', width / 2, height / 2);
              ctx.restore();
            }
          }
        });
      }
    );
  }

  create_signing_counter_bar_stacked(data) {
    const tax_invoice = data.tax_invoice;
    const receipt = data.receipt;
    const receipt_tax_invoice = data.receipt_tax_invoice;
    const invoice_tax_invoice = data.invoice_tax_invoice;
    const delivery_order_tax_invoice = data.delivery_order_tax_invoice;
    const credit_note = data.credit_note;
    const debit_note = data.debit_note;
    const invoice = data.invoice;
    const color = Chart.helpers.color;

    this.charts_signing_counter_bar_stacked_title = 'จำนวนครั้งการ Sign รายเดือน';
    const barChartData = {
      labels: this.monthList,
      datasets: [{
        label: this.translate.instant('TEXT.TI'),
        backgroundColor: color('rgb(230, 38, 31)').alpha(0.5).rgbString(),
        borderColor: 'rgb(230, 38, 31)',
        data: tax_invoice
      }, {
        label: this.translate.instant('TEXT.RC'),
        backgroundColor: color('rgb(235, 117, 50)').alpha(0.5).rgbString(),
        borderColor: 'rgb(235, 117, 50)',
        data: receipt
      }, {
        label: this.translate.instant('TEXT.RTI'),
        backgroundColor: color('rgb(247, 208, 56)').alpha(0.5).rgbString(),
        borderColor: 'rgb(247, 208, 56)',
        data: receipt_tax_invoice
      }, {
        label: this.translate.instant('TEXT.ITI'),
        backgroundColor: color('rgb(163, 224, 72)').alpha(0.5).rgbString(),
        borderColor: 'rgb(163, 224, 72)',
        data: invoice_tax_invoice
      }, {
        label: this.translate.instant('TEXT.DOTI'),
        backgroundColor: color('rgb(73, 218, 154)').alpha(0.5).rgbString(),
        borderColor: 'rgb(73, 218, 154)',
        data: delivery_order_tax_invoice
      }, {
        label: this.translate.instant('TEXT.CN'),
        backgroundColor: color('rgb(52, 187, 230)').alpha(0.5).rgbString(),
        borderColor: 'rgb(52, 187, 230)',
        data: credit_note
      }, {
        label: this.translate.instant('TEXT.DN'),
        backgroundColor: color('rgb(67, 85, 219)').alpha(0.5).rgbString(),
        borderColor: 'rgb(67, 85, 219)',
        data: debit_note
      }, {
        label: this.translate.instant('TEXT.I'),
        backgroundColor: color('rgb(210, 59, 231)').alpha(0.5).rgbString(),
        borderColor: 'rgb(210, 59, 231)',
        data: invoice
      }]
    };


    if (this.charts_signing_counter_bar_stacked == null) {
      this.charts_signing_counter_bar_stacked = new Chart('signing-counter-bar-chart', {
        type: 'bar',
        data: barChartData,
        options: {
          tooltips: {
            titleFontSize: 17,
            bodyFontSize: 17,
            mode: 'index',
            intersect: false,
            callbacks: this.getformatLabelFunction(this.translate.instant('COMMON.TIMES'), true)
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              stacked: true,
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          },
          legend: {
            position: 'top',
          }
        }
      });
    } else {
      this.charts_signing_counter_bar_stacked.config.options.tooltips.callbacks = this.getformatLabelFunction(this.translate.instant('COMMON.TIMES'), true);
      this.charts_signing_counter_bar_stacked.data = barChartData;
      this.charts_signing_counter_bar_stacked.update();
    }
  }

  getformatLabelFunction(unitName, showSum) {
    const tooltip = {
      label: function (tooltipItem, data) {
        let dataLabel = data.datasets[tooltipItem.datasetIndex].label;
        if (dataLabel == null)
          dataLabel = data.labels[tooltipItem.index];

        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        const valueStr = ' : ' + value.toLocaleString();
        dataLabel += valueStr + ' ' + unitName;

        if (showSum)
          window['total'] += value;

        return dataLabel;
      }
    };

    if (showSum) {
      tooltip['afterTitle'] = function () {
        window['total'] = 0;
      };

      tooltip['footer'] = (tooltipItem, data) => {
        const text = [this.translate.instant('CHART.TOTAL') + ' : ' + window['total'].toLocaleString() + ' ' + unitName +
        ((window['total'] >= 2 && unitName === 'Time') ? 's' : '')];
        return tooltipItem.length ? text : null;
      };
    }

    return tooltip;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}




// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-document/dashboard-document.component.ts